import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import TooltipContainer from './TooltipContainer';

const TooltipIcon = ({message}) => (
    <TooltipContainer tooltip={message}>
        <FontAwesomeIcon icon="question-circle" />
    </TooltipContainer>
);

export default TooltipIcon;
